namespace GeniuzPOS.Administration {
    export class UserApprovalRoleColumns {
        static columnsKey = 'Administration.UserApprovalRole';
    }
}
